var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPdfIcon = function SvgPdfIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "#ffffff",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14,2H6C4.9,2,4,2.9,4,4v16c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2V8L14,2z M15.923,17.698 c-0.241,0.568-0.722,0.811-1.283,0.649c-0.481-0.162-1.043-0.568-1.604-1.216c-0.561,0.081-1.123,0.243-1.684,0.405 c-0.642,1.135-1.283,2.108-1.925,2.351C9.266,19.968,9.106,20,8.945,20c-0.321,0-0.561-0.113-0.722-0.356 c-0.16-0.243-0.481-0.73,0.16-1.459c0.401-0.487,1.363-0.973,2.406-1.297c0.321-0.649,0.561-1.297,0.802-2.027 c-0.561-1.054-0.882-2.189-0.802-2.838C10.87,11.373,11.282,11,11.832,11s0.882,0.373,1.043,0.941c0.16,0.649,0,1.703-0.401,2.919 c0.241,0.487,0.561,0.973,0.882,1.459c0.962-0.081,1.764-0.081,2.246,0.243C16.003,16.806,16.083,17.211,15.923,17.698z M13,9V3.5 L18.5,9H13z",
    fill: "#ffffff"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPdfIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pdf_icon.70765fe6.svg";
export { ForwardRef as ReactComponent };